<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'软件检测'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">软件检测</p>
			<p class="t-align-center serviceT mt-10 mb-50">Software detection</p>
			<div class="m-0auto maxw-1400 pb-50">
				<p class="fz-24 line-26 mb-50 t-indent2">软件检测是在规定的条件下对程序进行操作，以发现程序错误，衡量软件质量，并对其是否能满足设计要求进行评估的过程。对软件形成中的文档、数据以及程序进行的测试，而不仅仅是对程序进行的测试。软件测试贯穿于整个软件生命周期中，测评流程如下：</p>
				<img src="../../assets/img/service/u14.png" alt="">
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
img{
	width: 100%;
}
</style>